import { render, staticRenderFns } from "./TermsOfServiceForConsumers.pug?vue&type=template&id=7cdf0de2&lang=pug&"
import script from "./TermsOfServiceForConsumers.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceForConsumers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports